import React from "react";
import { useSiteContent } from "../contexts/SiteContentContext";
import AnnouncementBanner from "./AnnouncementBanner";

/**
 * Hero — text vlevo, auto vpravo na stejné výškové úrovni. Pozadí sekce má
 * plynulý přechod: zleva (u textu) trochu světla, směrem doprava postupně
 * tmavne a u obrázku auta je čistě černé — takže foto (černé pozadí zapečené
 * do obrázku) do podkladu zcela zmizí, žádný glow kolem auta.
 */
export default function Hero({ onBook, onScrollServices }) {
  const { text } = useSiteContent();
  const h = text.hero || {};
  const headline = [h.headline_line1 || "Vaše auto", h.headline_line2 || "vrátíme do", h.headline_line3 || "salonního vzhledu."]
    .filter(Boolean)
    .join(" ");

  return (
    <section
      id="hero"
      className="relative overflow-hidden pt-[75px] pb-14 md:pt-32 md:pb-20 lg:min-h-[calc(100vh+15px)] lg:flex lg:items-center lg:pt-0 lg:pb-0 hero-bg"
      data-testid="hero-section"
    >
      <div className="relative w-full max-w-[1320px] mx-auto px-[22px] md:px-10 lg:px-24 grid lg:grid-cols-[600px_1fr] gap-5 lg:gap-6 items-center">
        {/* LEVÁ STRANA — text */}
        <div className="text-left order-2 lg:order-1 relative z-10">
          <span className="eyebrow text-akcent" data-testid="hero-eyebrow">{h.eyebrow || "Ruční Detailing"}</span>
          <h1 className="t-hero mt-4 lg:mt-6 text-krem-100" data-testid="hero-headline">
            {headline.replace(/\.$/, "")}<br /><span className="hero-athome">u vás doma</span>.
          </h1>
          <p className="t-body mt-5 lg:mt-8 text-krem-100/80 max-w-[506px]" data-testid="hero-subheadline">
            {(() => {
              const sub = h.subheadline || "Profesionální mytí a čištění aut s přípravky Auto Finesse a důslednou finální kontrolou kvality.";
              const idx = sub.indexOf("a důslednou finální");
              if (idx === -1) return sub;
              return (
                <>
                  {sub.slice(0, idx)}
                  <br className="hidden lg:block" />
                  {sub.slice(idx)}
                </>
              );
            })()}
          </p>
          <div className="mt-8 lg:mt-12 flex flex-wrap gap-3 lg:gap-5">
            <button onClick={onBook} className="btn-primary glow-cta" data-testid="hero-book-btn">
              <span>{h.cta_primary || "Rezervovat termín"}</span>
            </button>
            <button onClick={onScrollServices} className="btn-outline" data-testid="hero-services-btn">
              {h.cta_secondary || "Prohlédnout služby"}
            </button>
          </div>
        </div>

        {/* PRAVÁ STRANA — auto vystupující ze tmy, bez rámečku */}
        <div className="relative order-1 lg:order-2 -mx-[22px] md:mx-0 lg:mr-6 lg:pl-2 overflow-visible" data-testid="hero-car">
          <img
            src="/images/hero-car.png"
            alt="Detailně ošetřený vůz zepředu"
            className="car-light-up hero-car-img relative z-10 w-full h-auto select-none"
            draggable={false}
            fetchPriority="high"
            decoding="async"
            style={{
              WebkitMaskImage:
                "linear-gradient(to right, transparent 0%, #000 9%, #000 93%, transparent 100%), linear-gradient(to bottom, transparent 0%, #000 8%, #000 88%, transparent 100%)",
              maskImage:
                "linear-gradient(to right, transparent 0%, #000 9%, #000 93%, transparent 100%), linear-gradient(to bottom, transparent 0%, #000 8%, #000 88%, transparent 100%)",
              WebkitMaskComposite: "source-in",
              maskComposite: "intersect",
            }}
          />
        </div>
      </div>

      {/* Oznamovací pruh — na notebooku se vznáší přes spodní okraj hero
          sekce (bez něj je tam prostě pozadí hero); na mobilu zůstává v
          normálním toku pod obsahem, beze změny. */}
      <div className="lg:absolute lg:bottom-0 lg:inset-x-0 lg:z-20">
        <AnnouncementBanner />
      </div>
    </section>
  );
}
